export default __webpack_public_path__ + "static/media/electrode_placement.29997073.jpeg";